import {
  CROSS_AREA_CAR_POOL_BOOKINGS_FETCHING,
  CROSS_AREA_CAR_POOL_BOOKINGS_FAILED,
  CROSS_AREA_CAR_POOL_BOOKINGS_SUCCESS,
} from "../../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CROSS_AREA_CAR_POOL_BOOKINGS_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case CROSS_AREA_CAR_POOL_BOOKINGS_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case CROSS_AREA_CAR_POOL_BOOKINGS_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
